import shopifyHelper from "../../shopify";
import {hasher } from "../stores/hasher";

import GET_INVENTORY_ITEMS from '../../graphql/2024_01/inventory/get.graphql';

let inventoryLevels = null;
let deliveryMethods = null;
const useAuthenticated = true;

export const findinstore = {
    name: 'findinstore'
}

export default findinstore;
